import styled from "styled-components";
import { setFont } from "@similarweb/styles";
import { $robotoFontFamily, $dmSansFontFamily } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { AssetsService } from "app/services/AssetsService";

export const StyledContactsWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

export const StyledRequestAccessButton = styled(Button)`
    background-color: ${colorsPalettes.mint[400]};
    padding: 22px;
`;

export const StyledImg = styled.div<{ src: string }>`
    display: flex;
    align-content: center;
    justify-content: center;
    background-image: url(${({ src = "" }) => src && AssetsService.assetUrl(src)});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 100%;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const StyledTitleWrapper = styled.div`
    ${setFont({
        $size: 20,
        $weight: 500,
        $color: colorsPalettes.carbon[500],
        $family: $dmSansFontFamily,
    })};
    width: 638px;
    padding-bottom: 22px;
    line-height: 24px;
`;

export const StyledSubTitleWrapper = styled.div`
    ${setFont({
        $size: 14,
        $weight: 400,
        $color: colorsPalettes.carbon[400],
        $family: $robotoFontFamily,
    })};
    width: 638px;
    line-height: 22px;
    padding-bottom: 15px;
`;

export const StyledSubTitle = styled.div`
    ${setFont({
        $size: 12,
        $weight: 400,
        $color: colorsPalettes.carbon[300],
        $family: $robotoFontFamily,
    })};
    line-height: 20px;
`;

export const StyledTitle = styled.div`
    ${setFont({
        $size: 16,
        $weight: 500,
        $color: colorsPalettes.carbon[500],
        $family: $robotoFontFamily,
    })};
`;

export const StyledReachingImg = styled.img`
    height: 258px;
    width: 258px;
`;

export const StyledReachingWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    justify-content: center;
`;
